import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import CommonPage from "./page/CommonPage";
import { useEffect } from "react";
import { getLogin } from "./slices/LoginInfoSlice";
import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "./firebase";
import ContentWrap from "./page/content/ContentWrap";

export function formatTime(date) {
  // 시간과 분을 가져옴
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // 두 자리 숫자로 포맷팅
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  // HH:MM 형식의 문자열 반환
  return `${formattedHours}:${formattedMinutes}`;
}

function App() {
  sessionStorage.setItem("test", "test");
  const { status } = useSelector(state => state.LoginInfoSlice);
  const { roomId, message, users } = useSelector(state => state.GameSlice);

  const dispatch = useDispatch();
  useEffect(() => {
    if (roomId) {
      const ExitMessage = async e => {
        const docRef = doc(db, "game", `room${roomId}`);
        const lastOrder = message[0]?.order + 1 || 1;
        const userId = localStorage.getItem("id");
        const nickname = localStorage.getItem("nickname");
        const newMessage = {
          text: `님이 퇴장하였습니다.`,
          order: lastOrder,
          userId,
          nickname,
          type: "system",
          date: formatTime(new Date()),
        };
        const remainUsers = users.filter(i => i.userId !== userId);

        updateDoc(docRef, {
          message: arrayUnion(newMessage),
          users: remainUsers,
        });
      };

      window.addEventListener("beforeunload", ExitMessage);

      return () => window.removeEventListener("beforeunload", ExitMessage);
    }
  }, [roomId, message, users]);

  useEffect(() => {
    const id = localStorage.getItem("id");
    const nickname = localStorage.getItem("nickname");
    if (id && nickname) {
      dispatch(getLogin({ userId: id, nickname }));
    }
  }, [dispatch]);
  return (
    <Routes>
      {status ? (
        <>
          <Route path="" element={<ContentWrap />} />
          <Route path="/project/:roomId" element={<ContentWrap />} />
        </>
      ) : (
        <Route path="" element={<CommonPage />} />
      )}
    </Routes>
  );
}

export default App;
